import { cn } from '@/lib/utils'

interface BoxIconProps {
  className?: string
}

export function BoxIcon({ className }: BoxIconProps): React.ReactElement {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('size-6', className)}
    >
      <path
        d="M20.4901 7.51996C20.4844 7.49359 20.4844 7.46632 20.4901 7.43996C20.4852 7.41688 20.4852 7.39304 20.4901 7.36996V7.27996L20.4301 7.12996C20.4057 7.08903 20.3754 7.05196 20.3401 7.01996L20.2501 6.93996H20.2001L16.2601 4.44996L12.5401 2.14996C12.454 2.08169 12.3555 2.03075 12.2501 1.99996H12.1701C12.0807 1.98504 11.9894 1.98504 11.9001 1.99996H11.8001C11.6839 2.02565 11.5725 2.06952 11.4701 2.12996L4.00007 6.77996L3.91007 6.84996L3.82007 6.92996L3.72007 6.99996L3.67007 7.05996L3.61007 7.20996V7.29996V7.35996C3.60035 7.42627 3.60035 7.49365 3.61007 7.55996V16.29C3.60973 16.4599 3.6527 16.6271 3.73494 16.7759C3.81717 16.9246 3.93596 17.0499 4.08007 17.14L11.5801 21.78L11.7301 21.84H11.8101C11.9792 21.8936 12.1609 21.8936 12.3301 21.84H12.4101L12.5601 21.78L20.0001 17.21C20.1442 17.1199 20.263 16.9946 20.3452 16.8459C20.4274 16.6971 20.4704 16.5299 20.4701 16.36V7.62996C20.4701 7.62996 20.4901 7.55996 20.4901 7.51996ZM12.0001 4.16996L13.7801 5.26996L8.19007 8.72996L6.40007 7.62996L12.0001 4.16996ZM11.0001 19.17L5.50007 15.81V9.41996L11.0001 12.82V19.17ZM12.0001 11.06L10.0901 9.90996L15.6801 6.43996L17.6001 7.62996L12.0001 11.06ZM18.5001 15.78L13.0001 19.2V12.82L18.5001 9.41996V15.78Z"
        fill="currentColor"
      />
      <path
        d="M6.30005 9.9201L15.7001 4.1001L17.6001 5.2701L8.20005 11.1001L8.19995 12.6001L6.30005 11.6001V9.9201Z"
        fill="var(--color-primary)"
      />
    </svg>
  )
}
